import { Row, Skeleton } from 'antd';
import { PowerBIEmbed } from 'powerbi-client-react';
import React, { ReactElement, useEffect, useState } from 'react';
import { models } from 'powerbi-client';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { Payer } from '../../shared/models/payer.model';
import { FormInstance } from 'antd/lib/form';
import ApplicationDetail from '../../shared/services/applicationDetail.service';

interface INormalMode {
  pbiData: any;
  searchForm: FormInstance;
  sideForm: FormInstance;
  metricsBoardFilter?: any;
  reloadPbi: number;
  isLoading: boolean;
}

const NormalMode = (props: INormalMode): ReactElement => {
  const appDetail = ApplicationDetail.instance;
  const groupProviders = appDetail?.getGroupProviders();
  const {
    pbiData,
    searchForm,
    sideForm,
    metricsBoardFilter,
    reloadPbi,
    isLoading,
  } = props;
  const configuredPayers = useSelector((state: RootState): Payer[] => state?.payerList?.allPayers || []);
  const [filters, setFilters] = useState<any[]>([]);

  const getPbiFilters = (): any => {
    const filterToSet: any[] = [];
    const {
      searchCenter,
      searchPayer,
      fromMonth,
      toMonth,
    } = metricsBoardFilter || searchForm.getFieldsValue(['searchCenter', 'searchPayer', 'fromMonth', 'toMonth']);
    const { type } = sideForm.getFieldsValue(['type']);

    if (searchCenter?.length) {
      filterToSet.push(
        {
          $schema: 'http://powerbi.com/product/schema#advanced',
          target: {
            table: 'ClaimData',
            column: 'IHXHospitalID',
          },
          operator: 'In',
          values: searchCenter?.map((ele: any): any => String(ele)),
        },
      );
    } else if (groupProviders?.length > 0) {
      filterToSet.push(
        {
          $schema: 'http://powerbi.com/product/schema#advanced',
          target: {
            table: 'ClaimData',
            column: 'IHXHospitalID',
          },
          operator: 'In',
          values: groupProviders?.map((ele: Payer): any => ele?.key),
        },
      );
    } else {
      filterToSet.push(
        {
          $schema: 'http://powerbi.com/product/schema#advanced',
          target: {
            table: 'ClaimData',
            column: 'IHXHospitalID',
          },
          operator: 'In',
          values: [String(appDetail?.getProviderId())],
        },
      );
    }

    if (searchPayer) {
      const selectedPayers = configuredPayers?.filter((ele: Payer): boolean => searchPayer?.includes(ele?.uniqueIdentifier));
      if (selectedPayers?.length) {
        filterToSet.push({
          $schema: 'http://powerbi.com/product/schema#advanced',
          target: {
            table: 'ClaimData',
            column: 'FinalPayerName',
          },
          operator: 'In',
          values: selectedPayers.map((ele: Payer): any => ele?.uniqueIdentifier),
        });
      }
    }
    if (type) {
      filterToSet.push(
        {
          $schema: 'http://powerbi.com/product/schema#advanced',
          target: {
            table: 'ClaimData',
            column: 'CorporateType',
          },
          operator: 'In',
          values: [type],
        },
      );
    }
    if (fromMonth && toMonth) {
      const startDate: any = new Date(metricsBoardFilter?.fromMonth);
      const endDate: any = new Date(metricsBoardFilter?.toMonth);
      const updatedStartDate: any =
        new Date(`${startDate?.getMonth() + 1} ${startDate?.getDate()} ${startDate?.getFullYear()} 00:00:01 UTC`);
      const updatedEndDate: any = new Date(`${endDate?.getMonth() + 1} ${endDate?.getDate()} ${endDate?.getFullYear()} 23:59:59 UTC`);

      filterToSet.push(
        {
          $schema: 'http://powerbi.com/product/schema#advanced',
          target: {
            table: 'ClaimData',
            column: 'ClaimSubmittedDate',
          },
          logicalOperator: 'And',
          conditions: [
            {
              operator: 'GreaterThanOrEqual',
              value: new Date(updatedStartDate).toJSON().slice(0, -1),
            },
            {
              operator: 'LessThan',
              value: new Date(updatedEndDate).toJSON().slice(0, -1),
            },
          ],
        },
      );
    }

    setFilters(filterToSet);
  };

  useEffect((): any => {
    getPbiFilters();
  }, [reloadPbi, groupProviders, metricsBoardFilter]);

  return (
    isLoading ?
      <Row className="mr-10 ml-10 mt-md mb-md"><Skeleton/></Row> :
      (
        pbiData &&
        <PowerBIEmbed
          embedConfig={{
            type: 'report',
            id: pbiData?.id,
            embedUrl: pbiData?.embedUrl,
            accessToken: pbiData?.embedToken?.token,
            tokenType: models.TokenType.Embed,
            permissions: models.Permissions.All,
            settings: {
              hideErrors: false,
              filterPaneEnabled: false,
              navContentPaneEnabled: false,
              bookmarksPaneEnabled: false,
              localeSettings: {
                formatLocale: '',
                language: '',
              },
            },
            filters: [...filters],
          }}
          cssClassName={'core-pbi-dashboard'}
        />
      )
  );
};
export default NormalMode;
